export default __webpack_public_path__ + "static/media/clock.a1ef5456.svg";